import _ from 'lodash';
import React from 'react';
import { connect as reactReduxConnect } from 'react-redux';
import { io as socketio } from "socket.io-client";
// @ts-expect-error
import { jitsiLocalStorage } from '@jitsi/js-utils';
// @ts-expect-error
import VideoLayout from '../../../../../modules/UI/videolayout/VideoLayout';
import { getConferenceNameForTitle } from '../../../base/conference/functions';
import { hangup } from '../../../base/connection/actions.web';
import { isMobileBrowser } from '../../../base/environment/utils';
import { translate } from '../../../base/i18n/functions';
import { setColorAlpha } from '../../../base/util/helpers';
import MainFilmstrip from '../../../filmstrip/components/web/MainFilmstrip';
import ScreenshareFilmstrip from '../../../filmstrip/components/web/ScreenshareFilmstrip';
import StageFilmstrip from '../../../filmstrip/components/web/StageFilmstrip';
import CalleeInfoContainer from '../../../invite/components/callee-info/CalleeInfoContainer';
import LargeVideo from '../../../large-video/components/LargeVideo.web';
import { getIsLobbyVisible } from '../../../lobby/functions';
import { getOverlayToRender } from '../../../overlay/functions.web';
import ParticipantsPane from '../../../participants-pane/components/web/ParticipantsPane';
import Prejoin from '../../../prejoin/components/web/Prejoin';
import { isPrejoinPageVisible } from '../../../prejoin/functions.web';
import ReactionAnimations from '../../../reactions/components/web/ReactionsAnimations';
import { toggleToolboxVisible } from '../../../toolbox/actions.any';
import { fullScreenChanged, showToolbox } from '../../../toolbox/actions.web';
import JitsiPortal from '../../../toolbox/components/web/JitsiPortal';
import Toolbox from '../../../toolbox/components/web/Toolbox';
import { LAYOUT_CLASSNAMES } from '../../../video-layout/constants';
import { getCurrentLayout } from '../../../video-layout/functions.any';
import VisitorsQueue from '../../../visitors/components/web/VisitorsQueue';
import { showVisitorsQueue } from '../../../visitors/functions';
import { init } from '../../actions.web';
import { maybeShowSuboptimalExperienceNotification } from '../../functions.web';
import { AbstractConference, abstractMapStateToProps } from '../AbstractConference';
import { DEFAULT_SIP_SERVER, PAGE_AUTH, PATH_ROOT, SOCKET_URL } from '../../../../../modules/API/constants_ts';
import ApiManagerUser from '../../../api/ApiManagerUser';
import { checkIsJibri, checkSipGateway } from '../../../app/functions.any';
import { MEETING_STATUS } from '../../../base/app/constants';
import { MEDIA_TYPE } from '../../../base/media/constants';
import { getAccessToken, getRefreshToken } from '../../../base/util/cookies';
import ChatPane from '../../../chat/components/web/ChatPane';
import FeedbackPage from '../../../feedback/components/FeedbackPage';
import { setFilmstripVisible } from '../../../filmstrip/actions.any';
import { listen } from '../../../invite/actions.any';
import MenuController from '../../../moderator-controller';
import { NOTIFICATION_TIMEOUT_TYPE, showNotification } from '../../../notifications';
import { updateUserFunctions } from '../../../user/slice';
import { muteLocal } from '../../../video-menu/actions.any';
import ConferenceInfo from './ConferenceInfo';
import ModerationHandler from './ModerationHandler';
import { default as Notice } from './Notice';
import axiosClient from '../../../api/axiosClient';
import { refreshTokenWrapper } from '../../../api/axiosClient';
import LiveCaptions from './LiveCaptions';
import { setEnableSubtitle } from '../../../subtitles/actions.any';
import { isLocalParticipantModerator } from '../../../base/participants';
import { setEnableSaveLiveCaption } from '../../../live-caption/slice';
import SaveCaptionPopover from '../../../base/app/components/SaveCaptionPopover';
import { checkOwnerCaption } from '../../../base/util/functions';
import { setIsPaging } from '../../../filmstrip/actions.web';
import { toggleNoiseSuppression } from '../../../noise-suppression/actions';
import { isNoiseSuppressionEnabled } from '../../../noise-suppression/functions';
/**
 * DOM events for when full screen mode has changed. Different browsers need
 * different vendor prefixes.
 *
 * @private
 * @type {Array<string>}
 */
const FULL_SCREEN_EVENTS = [
    'webkitfullscreenchange',
    'mozfullscreenchange',
    'fullscreenchange'
];
// interface IState {
//     isCalledLivecaption: boolean
//     isSipLogin: boolean
// }
let socket = null;
export async function initializeSocket() {
    try {
        let token = getAccessToken();
        const roomID = window.location.pathname.split("/")[1];
        globalThis.webSocket = socket = socketio(SOCKET_URL, {
            path: PATH_ROOT + '/socket.io',
            query: {
                type: 'meeting'
            },
            auth: {
                token: token,
                roomId: roomID,
            },
        });
        socket.on('expired-authentication', async () => {
            const newToken = await refreshTokenWrapper();
            socket.emit('re-authentication', newToken);
        });
    }
    catch (error) {
        console.log("SOCKET INIT ERROR:", error);
    }
}
// Gọi hàm initializeSocket để khởi tạo kết nối socket
initializeSocket();
// let socketAI: any = null;
// declare global {
//     var webSocketAI: any;
// }
// async function initializeSocketAI(): Promise<void> {
//     try {
//         const token = await getAccessToken();
//         const roomID = window.location.pathname.split("/")[1];
//         globalThis.webSocketAI = socketAI = socketio(SOCKET_AI_URL, {
//             query: { type: "meeting" },
//             auth: {
//                 token,
//                 roomId: roomID,
//             },
//         });
//         socketAI.on("expired-authentication", async () => {
//             const newToken = await refreshTokenWrapper();
//             socketAI.emit("re-authentication", newToken);
//         });
//     } catch (error) {
//         console.error("SOCKET INIT ERROR:", error);
//     }
// }
// // Initialize the socket connection with the AI server.
// initializeSocketAI();
/**
 * The conference page of the Web application.
 */
class Conference extends AbstractConference {
    /**
     * Initializes a new Conference instance.
     *
     * @param {Object} props - The read-only properties with which the new
     * instance is to be initialized.
     */
    constructor(props) {
        super(props);
        this.state = {
            isSipLogin: false,
            isTriedSelfLogin: false,
            isSipCallSuccess: false,
            urlParams: null,
            sipList: null,
            gotSipList: false,
            gotInvitee: false,
            invitees: null,
            listenNumber: 0,
            isCalledLivecaption: false,
            isReadyAutoCall: false,
            sipCalls: null,
            sipListen: null
        };
        const { _mouseMoveCallbackInterval } = props;
        // Throttle and bind this component's mousemove handler to prevent it
        // from firing too often.
        this._originalOnShowToolbar = this._onShowToolbar;
        this._originalOnMouseMove = this._onMouseMove;
        this._onShowToolbar = _.throttle(() => this._originalOnShowToolbar(), 100, {
            leading: true,
            trailing: false
        });
        this._onMouseMove = _.throttle(event => this._originalOnMouseMove(event), _mouseMoveCallbackInterval, {
            leading: true,
            trailing: false
        });
        // Bind event handler so it is only bound once for every instance.
        this._onFullScreenChange = this._onFullScreenChange.bind(this);
        this._onVidespaceTouchStart = this._onVidespaceTouchStart.bind(this);
        this._setBackground = this._setBackground.bind(this);
        this.state = {
            isCalledLivecaption: false
        };
    }
    /**
     * Start the connection and get the UI ready for the conference.
     *
     * @inheritdoc
     */
    async componentDidMount() {
        document.title = `${this.props._roomName} | ${interfaceConfig.APP_NAME || "Viettel Meeting Platform"}`;
        if (this.props.iAmSipGateway || checkSipGateway()) {
            // APP.store.dispatch(muteLocal(false, MEDIA_TYPE.VIDEO));
            // APP.store.dispatch(muteLocal(false, MEDIA_TYPE.AUDIO));
            APP.store.dispatch(setFilmstripVisible(false));
            setTimeout(() => {
                APP.store.dispatch(muteLocal(false, MEDIA_TYPE.VIDEO));
                APP.store.dispatch(muteLocal(false, MEDIA_TYPE.AUDIO));
            }, 3000);
        }
        if (!checkIsJibri() && (getAccessToken() && getRefreshToken())) {
            try {
                const result = await ApiManagerUser.getUserFunctions();
                if (result?.status === 'success') {
                    APP.store.dispatch(updateUserFunctions(result?.data));
                }
            }
            catch (error) {
                console.log("[Error]: can't get user functions: ", error);
            }
        }
        if (checkIsJibri()) {
            this.props.dispatch(setIsPaging(true));
            jitsiLocalStorage.setItem("isPaging", "true");
            if (this.props._isNoiseSuppressionEnabled) {
                APP.store.dispatch(toggleNoiseSuppression());
            }
        }
        this._start();
    }
    /**
     * Calls into legacy UI to update the application layout, if necessary.
     *
     * @inheritdoc
     * returns {void}
     */
    componentDidUpdate(prevProps) {
        if (!checkIsJibri()
            && !this.state.isSipLogin
            && !this.state.isTriedSelfLogin
            && this.props._conference) {
            this.loginSelfSip(false);
        }
        if (!this.state.isCalledLivecaption && APP.store.getState()['features/base/conference']?.conference) {
            socket.emit("check_live_caption_room_client", true);
            this.setState({ isCalledLivecaption: true });
        }
        socket.on("check_live_caption_room_server", (data) => {
            if (data == true && !this.props.enableSubtitle) {
                this.props.dispatch(setEnableSubtitle(true));
            }
        });
        if (isLocalParticipantModerator(APP.store.getState())) {
            let liveCaptionSaveStatus = 2;
            socket.emit("enable_save_live_caption_client", liveCaptionSaveStatus);
            socket.once("enable_save_live_caption_server", (data) => {
                liveCaptionSaveStatus = data;
                this.props.dispatch(setEnableSaveLiveCaption(liveCaptionSaveStatus === 1));
                if (liveCaptionSaveStatus === 1) {
                    checkOwnerCaption(this.props.dispatch, APP.store.getState());
                }
            });
        }
        if (this.props._shouldDisplayTileView
            === prevProps._shouldDisplayTileView) {
            return;
        }
        // TODO: For now VideoLayout is being called as LargeVideo and Filmstrip
        // sizing logic is still handled outside of React. Once all components
        // are in react they should calculate size on their own as much as
        // possible and pass down sizings.
        VideoLayout.refreshLayout();
    }
    /**
     * Disconnect from the conference when component will be
     * unmounted.
     *
     * @inheritdoc
     */
    componentWillUnmount() {
        APP.UI.unbindEvents();
        FULL_SCREEN_EVENTS.forEach(name => document.removeEventListener(name, this._onFullScreenChange));
        APP.conference.isJoined() && this.props.dispatch(hangup());
    }
    async processAutoCallSip() {
        if ((this.state.sipCalls || this.state.sipListen) && !this.props.autoCall) {
            const sip_calls = [];
            if (this.state.sipCalls) {
                this.state.sipCalls.trim().split(/[\s,;]+/).forEach((directSipCode) => {
                    if (directSipCode) {
                        if (directSipCode.includes("@")) {
                            const sipContact = directSipCode.split('@');
                            sip_calls.push({
                                id: directSipCode,
                                name: sipContact[0],
                                type: "videosipgw"
                            });
                        }
                        else {
                            sip_calls.push({
                                id: `${directSipCode}@${DEFAULT_SIP_SERVER}`,
                                name: directSipCode,
                                type: "videosipgw"
                            });
                        }
                    }
                });
            }
            this.setState({ invitees: sip_calls, gotInvitee: true, listenNumber: this.state.sipListen ? this.state.sipListen : 0 });
        }
    }
    async loginSelfSip(notification = true) {
        this.setState({ isTriedSelfLogin: true });
        await axiosClient.post(PAGE_AUTH + "/vmp/get-available-account", {
            roomId: window.location.pathname.split("/")[1],
        })
            .then((data) => {
            const username = data?.username;
            const domain = data?.domain;
            const password = data?.password;
            if (username) {
                const sip_call = data?.sip_call;
                const sip_listen = data?.sip_listen;
                this.setState({ sipCalls: sip_call, sipListen: sip_listen });
                setTimeout(() => {
                    // this.processAutoCallSip(sip_call, sip_listen)
                    this.setState({ isReadyAutoCall: true });
                }, 500);
                this.setState({ isSipLogin: true });
                APP.store
                    .dispatch(listen(username, password, domain, this.props._conference, false))
                    .then(() => { });
            }
        })
            .catch(() => {
            if (notification) {
                APP.store.dispatch(showNotification({
                    titleKey: "Chưa được cấp tài khoản Cầu truyền hình, liên hệ đầu mỗi hỗ trợ để được cấp!",
                }, NOTIFICATION_TIMEOUT_TYPE.LONG));
            }
        });
    }
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    render() {
        const { _isAnyOverlayVisible, _layoutClassName, _notificationsVisible, _overflowDrawer, _showLobby, _showPrejoin, _showVisitorsQueue, t, _canShowFeedback, _isShowFeedback } = this.props;
        return (React.createElement("div", { id: 'layout_wrapper', onMouseEnter: this._onMouseEnter, onMouseLeave: this._onMouseLeave, onMouseMove: this._onMouseMove, ref: this._setBackground },
            _canShowFeedback &&
                _isShowFeedback !== MEETING_STATUS.MEETING &&
                React.createElement("div", { id: "feedback-bgr" }, _isShowFeedback !== MEETING_STATUS.MEETING && React.createElement(FeedbackPage, null)),
            React.createElement("div", { className: _layoutClassName, id: 'videoconference_page', onMouseMove: isMobileBrowser() ? undefined : this._onShowToolbar },
                React.createElement(SaveCaptionPopover, null),
                React.createElement(LiveCaptions, null),
                React.createElement(ConferenceInfo, null),
                React.createElement(Notice, null),
                React.createElement("div", { id: 'videospace', onTouchStart: this._onVidespaceTouchStart },
                    React.createElement(LargeVideo, null),
                    _showPrejoin || _showLobby || (React.createElement(React.Fragment, null,
                        React.createElement(StageFilmstrip, null),
                        React.createElement(ScreenshareFilmstrip, null),
                        React.createElement(MainFilmstrip, null)))),
                _showPrejoin || _showLobby || (React.createElement(React.Fragment, null,
                    React.createElement("span", { "aria-level": 1, className: 'sr-only', role: 'heading' }, t('toolbar.accessibilityLabel.heading')),
                    React.createElement(Toolbox, null))),
                _notificationsVisible && !_isAnyOverlayVisible && (_overflowDrawer
                    ? React.createElement(JitsiPortal, { className: 'notification-portal' }, this.renderNotificationsContainer({ portal: true }))
                    : this.renderNotificationsContainer()),
                React.createElement(CalleeInfoContainer, null),
                (_showPrejoin && !_showVisitorsQueue) && React.createElement(Prejoin, null),
                _showVisitorsQueue && React.createElement(VisitorsQueue, null)),
            React.createElement(MenuController, null),
            React.createElement(ModerationHandler, null),
            React.createElement(ParticipantsPane, null),
            React.createElement(ReactionAnimations, null),
            React.createElement(ChatPane, null)));
    }
    /**
     * Sets custom background opacity based on config. It also applies the
     * opacity on parent element, as the parent element is not accessible directly,
     * only though it's child.
     *
     * @param {Object} element - The DOM element for which to apply opacity.
     *
     * @private
     * @returns {void}
     */
    _setBackground(element) {
        if (!element) {
            return;
        }
        if (this.props._backgroundAlpha !== undefined) {
            const elemColor = element.style.background;
            const alphaElemColor = setColorAlpha(elemColor, this.props._backgroundAlpha);
            element.style.background = alphaElemColor;
            if (element.parentElement) {
                const parentColor = element.parentElement.style.background;
                const alphaParentColor = setColorAlpha(parentColor, this.props._backgroundAlpha);
                element.parentElement.style.background = alphaParentColor;
            }
        }
    }
    /**
     * Handler used for touch start on Video container.
     *
     * @private
     * @returns {void}
     */
    _onVidespaceTouchStart() {
        this.props.dispatch(toggleToolboxVisible());
    }
    /**
     * Updates the Redux state when full screen mode has been enabled or
     * disabled.
     *
     * @private
     * @returns {void}
     */
    _onFullScreenChange() {
        this.props.dispatch(fullScreenChanged(APP.UI.isFullScreen()));
    }
    /**
     * Triggers iframe API mouseEnter event.
     *
     * @param {MouseEvent} event - The mouse event.
     * @private
     * @returns {void}
     */
    _onMouseEnter(event) {
        APP.API.notifyMouseEnter(event);
    }
    /**
     * Triggers iframe API mouseLeave event.
     *
     * @param {MouseEvent} event - The mouse event.
     * @private
     * @returns {void}
     */
    _onMouseLeave(event) {
        APP.API.notifyMouseLeave(event);
    }
    /**
     * Triggers iframe API mouseMove event.
     *
     * @param {MouseEvent} event - The mouse event.
     * @private
     * @returns {void}
     */
    _onMouseMove(event) {
        APP.API.notifyMouseMove(event);
    }
    /**
     * Displays the toolbar.
     *
     * @private
     * @returns {void}
     */
    _onShowToolbar() {
        this.props.dispatch(showToolbox());
    }
    /**
     * Until we don't rewrite UI using react components
     * we use UI.start from old app. Also method translates
     * component right after it has been mounted.
     *
     * @inheritdoc
     */
    _start() {
        APP.UI.start();
        APP.UI.bindEvents();
        FULL_SCREEN_EVENTS.forEach(name => document.addEventListener(name, this._onFullScreenChange));
        const { dispatch, t } = this.props;
        dispatch(init());
        maybeShowSuboptimalExperienceNotification(dispatch, t);
    }
}
/**
 * Maps (parts of) the Redux state to the associated props for the
 * {@code Conference} component.
 *
 * @param {Object} state - The Redux state.
 * @private
 * @returns {IProps}
 */
function _mapStateToProps(state) {
    const { backgroundAlpha, mouseMoveCallbackInterval } = state['features/base/config'];
    const { overflowDrawer } = state['features/toolbox'];
    const { conference } = state['features/base/conference'];
    const { isShowFeedback } = state['features/feedback'];
    const { iAmSipGateway } = state['features/base/config'];
    const { enableSubtitle } = state['features/subtitles'];
    return {
        ...abstractMapStateToProps(state),
        _backgroundAlpha: backgroundAlpha,
        _isAnyOverlayVisible: Boolean(getOverlayToRender(state)),
        _layoutClassName: LAYOUT_CLASSNAMES[getCurrentLayout(state) ?? ''],
        _mouseMoveCallbackInterval: mouseMoveCallbackInterval,
        _overflowDrawer: overflowDrawer,
        _roomName: getConferenceNameForTitle(state),
        _showLobby: getIsLobbyVisible(state),
        _showPrejoin: isPrejoinPageVisible(state),
        _showVisitorsQueue: showVisitorsQueue(state),
        _canShowFeedback: !conference,
        _isShowFeedback: isShowFeedback,
        autoCall: state["features/videosipgw"].autoCall,
        _conference: conference,
        iAmSipGateway,
        enableSubtitle,
        _isNoiseSuppressionEnabled: isNoiseSuppressionEnabled(state)
    };
}
export default reactReduxConnect(_mapStateToProps)(translate(Conference));
